// Timeline
// Scripts to fire once dom has loaded
document.addEventListener("DOMContentLoaded", () => {
    const sections = document.querySelectorAll(".timeline-js");

    window.addEventListener("scroll", navHighlighter);

    function navHighlighter() {

        let scrollY = window.pageYOffset;

        sections.forEach(current => {
            const sectionHeight = current.offsetHeight;
            const sectionTop = current.offsetTop - 50;
            var sectionId = current.getAttribute("id");

            if (
                scrollY > sectionTop &&
                scrollY <= sectionTop + sectionHeight
            ) {
                document.querySelector(".section-timeline__list li[href*=" + sectionId + "]").classList.add("active");
            } else {
                document.querySelector(".section-timeline__list li[href*=" + sectionId + "]").classList.remove("active");
            }
        });
    }
});